import { useQuery } from "@apollo/client";
import { EntityTypeFilterValue } from "../../../../legacy/types/companyFilter";
import { ATTRIBUTE_PRODUCT_TABLE_QUERY } from "../queries";
import { ProductQueryPayload } from "../types";
import { TAXONOMY_CLIENT } from "../../../../utils/consts";

export const useProductTableQuery = (
  attributeId: number | undefined,
  localizeInstalls: boolean,
  entityTypeFilterValue: EntityTypeFilterValue
) => {
  const { data, loading } = useQuery<ProductQueryPayload>(
    ATTRIBUTE_PRODUCT_TABLE_QUERY,
    {
      variables: {
        attributeId,
        localizeInstalls,
        ...entityTypeFilterValue,
      },
      skip: !attributeId,
      context: { clientName: TAXONOMY_CLIENT },
    }
  );

  const products = data?.product.data || [];

  return { loading, products };
};
